// Call History-related filters

import { createDateRangeFilter, createRadioFilter } from './factories';
import type { FilterRegistry } from './types';

export const callHistoryFilters: FilterRegistry = {
	callHistoryDateRange: {
		...createDateRangeFilter({
			label: 'Date Range',
			objectTable: 'call_user',
			dateField: 'date',
			listKeys: [
				'call_history',
				'call-history-client-embedded',
				'call-history-vendor-embedded',
			],
		}),
		queryParamName: 'callHistoryDateRange',
		allowClear: true,
	},

	callHistoryUser: {
		type: 'multi-select',
		label: 'User',
		placeholder: 'Select users...',
		colorScheme: 'blue',
		searchable: true,
		loadOnFocus: true,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'display_name' as keyof unknown,
		},
		queryParamName: 'callHistoryUser',
		apiEndpoint: '/users',
		multiple: true,
		options: [{ id: 'ME', label: 'Me' }],
		queryMapping: {
			objectTable: 'call_user',
			fieldName: 'fkUserId',
			joinType: 'direct',
		},
		format: 'array',
		valueExtractor: {
			property: 'id',
		},
		listKeys: [
			'call_history',
			'call-history-client-embedded',
			'call-history-vendor-embedded',
		],
	},

	callHistoryDirection: {
		...createRadioFilter({
			label: 'Direction',
			options: [
				{ id: 'All', label: 'All' },
				{ id: 'inbound', label: 'Inbound' },
				{ id: 'outbound', label: 'Outbound' },
			],
			defaultValue: { id: 'All', label: 'All' },
			objectTable: 'call_user',
			fieldName: 'direction',
			listKeys: [
				'call_history',
				'call-history-client-embedded',
				'call-history-vendor-embedded',
			],
			colorScheme: 'purple',
		}),
		queryParamName: 'callHistoryDirection',
	},

	callHistoryInternalExternal: {
		...createRadioFilter({
			label: 'Internal/External',
			options: [
				{ id: 'All', label: 'All' },
				{ id: '0', label: 'External' },
				{ id: '1', label: 'Internal' },
			],
			defaultValue: { id: 'All', label: 'All' },
			objectTable: 'call_user',
			fieldName: 'isInternal',
			listKeys: [
				'call_history',
				'call-history-client-embedded',
				'call-history-vendor-embedded',
			],
			colorScheme: 'orange',
		}),
		queryParamName: 'callHistoryInternalExternal',
	},
};
